//require ("../../typescript/common");
import { getSiteResDomain } from "../../core/common";
export class SsmAdsBeitou{    
    styleUrl:string = "http://image.feedtrade.com.cn/assets/components/ads/beitou.css";
    id:string = "";
    tpl:string = '<div class="ssm-ads-beitou">'+
            '<div class="big"></div>'+
            '<div class="small"></div>'+
            '<div class="reset">重播</div>'+
            '</div>';
    obj:any;
    constructor(id:string, big:string='',small:string=''){
        this.id = id;
        if($("#"+this.id).length==0){
            this.obj = $(this.tpl);//需要先赋值,后续操作结果才能保存
            $(this.obj).attr('id',id);
            if(big.length>0){                
                $(this.obj).find('.big').append(big);
            }
            if(small.length>0){
                $(this.obj).find('.small').html(small);
            }
            //this.tpl = this.obj.get(0).innerHTML;
            //document.write(this.obj.get(0).innerHTML);//不能用document.write，要不后续jquery无法控制
            $('body').append($(this.obj));
            //console.log($("#"+this.id));
        }
        this.obj = $("#"+this.id);   
        //console.log($(this.obj).html());
    }
    init(){
        let _self = this;
        $(document).ready(() => {
            if($(this.obj).find('.big').html().length<60){
                $(this.obj).hide();
                //console.log('no');
            }else{
                $(this.obj).show();
                //console.log('ok');
                let domain = getSiteResDomain();
                //let host2 = document.domain; 
                var style = document.createElement('link');
                style.href = domain + this.styleUrl;
                style.rel = 'stylesheet';
                style.type = 'text/css';
                document.getElementsByTagName('HEAD').item(0).appendChild(style);
                this.play();
            }
            $(this.obj).find('.reset').click(function(){
                _self.replay();
            });
        })
    }
    play(){
        $(this.obj).find('.big').delay(3500).slideUp(1000);//显示大图	
        $(this.obj).find('.small').delay(3500).slideDown(1000);//显示小图
        $(this.obj).find('.reset').delay(3500).slideDown(1000);
    }
    replay(){//重播            
            //console.log('replay');
            $(this.obj).find('.small').hide();
            $(this.obj).find('.reset').hide();		
			$(this.obj).find('.big').slideDown();
            this.play();
    }
}


